<template>
  <section class="section container pt-0">
    <div class="title is-3">{{ $t("welcome") }} {{ member.name }}</div>
    <div class="subtitle is-4">
      {{ $t("hours remaining") }}
      <span class="has-text-primary">{{ member.remaining_hours }}</span>
    </div>

    <div class="grid is-col-min-7">
      <div class="cell" @click="make_reservation">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2534/2534679.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("book now") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="my_reservations">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/7061/7061954.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("my reservations") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="buy_time">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2972/2972576.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("credit hours") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <reserve-modal ref="reserve_modal" />
  </section>
</template>

<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
} from "@/utils";
import ReserveModal from "./reserve_modal/Index.vue";

export default {
  name: "ReservationIndex",
  components: { ReserveModal },
  data() {
    return {
      is_loading: false,
      member: {},
      stations: [],
      availability: [],
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    make_reservation() {
      this.$router.push({
        path: "/pilates_member/booking/" + this.member.uuid,
      });
    },
  },
  mounted() {
    let v = this;
    let member_uuid = v.$route.params.uuid;
    get("/pilates_member/reservation/member", { uuid: member_uuid })
      .then((member) => {
        v.member = member;
      })
      .catch((error) => {
        error_message(error);
      });
  },
  created() {
    let v = this;
    let member_uuid = v.$route.params.uuid;
    get("/pilates_member/reservation/stations", { uuid: member_uuid })
      .then((r) => {
        v.stations = r.stations;
        v.availability = r.availability;
      })
      .catch((error) => {
        error_message(error);
      });
  },
};
</script>

<style scoped></style>
